import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { getCourseSubscriptionSession, subscribeCourse } from './api';
import { RootState } from '../..';

export interface ICourseSubscriptionSession {
  _id: string;
  course: string;
  status: 'PENDING' | 'PAID';
  stripeProductId: string;
  stripeSession: {
    url: string;
  };
}

export interface IStripeV2State {
  status: 'idle' | 'loading' | 'rejected';
  courseSubscriptionSession?: ICourseSubscriptionSession;
}

const initialState: IStripeV2State = {
  status: 'idle',
  courseSubscriptionSession: undefined,
};

export const StripeSlice = createSlice({
  name: 'stripeV2',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(subscribeCourse.fulfilled, (state, action) => {
        state.status = 'idle';

        const result = action.payload;

        if (result && result.stripeSession && result.stripeSession.url) {
          window.location.href = result.stripeSession.url;
        }
      })
      .addCase(getCourseSubscriptionSession.fulfilled, (state, action) => {
        state.status = 'loading';

        const result = action.payload;
        state.courseSubscriptionSession = result;
      });

    // Matchers
    builder
      .addMatcher(
        isPending(subscribeCourse, getCourseSubscriptionSession),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        isRejected(subscribeCourse, getCourseSubscriptionSession),
        (state) => {
          state.status = 'rejected';
        }
      );
  },
});

export const getStripeV2State = (state: RootState): RootState['stripeV2'] =>
  state.stripeV2;

export * from './api';
export default StripeSlice.reducer;
